import { useLang } from "../i18n";
import { Reveal, Eyebrow, SectionShell } from "./Reveal";

const DRIVE_PARTITURA_URL =
  "https://drive.google.com/file/d/1M9-W4bmq8xvlShpGgceCFKssHUduc1qJ/view?usp=sharing";

export default function About() {
  const { t } = useLang();

  return (
    <SectionShell id="manoscritto" testid="about-universe-section" className="overflow-hidden">
      <div className="max-w-3xl text-center">
        <div>
          <Reveal>
            <Eyebrow>{t.about.eyebrow}</Eyebrow>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
              {t.about.title}
            </h2>
          </Reveal>

          <Reveal delay={0.1} className="mt-8 space-y-5 text-slate-600 leading-relaxed text-base sm:text-lg">
            <p>{t.about.p1}</p>
            <p>{t.about.p2}</p>
            <p>{t.about.p3}</p>
            <p>{t.about.p4}</p>
          </Reveal>

          <Reveal delay={0.15} className="mt-8">
            <p className="text-slate-700 font-semibold">
              {t.about.scoreLead}{" "}
              <a
                href={DRIVE_PARTITURA_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="score-download-btn"
                className="font-bold text-sky-700 underline underline-offset-4 decoration-2 decoration-sky-400 hover:text-sky-600 hover:decoration-amber-400 transition-colors"
              >
                {t.about.scoreLink}
              </a>
              :
            </p>
          </Reveal>

          <Reveal delay={0.2} className="mt-10">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">{t.about.tokenTitle}</p>
            <p className="mt-3 text-slate-600 leading-relaxed">{t.about.p5}</p>
            <p className="mt-4 text-slate-600 leading-relaxed">{t.about.p6}</p>
          </Reveal>

          <Reveal delay={0.1} className="mt-8">
            <blockquote className="font-serif-accent italic text-2xl sm:text-3xl text-slate-800 leading-snug">
              {t.about.artistQuote}
            </blockquote>
          </Reveal>
        </div>
      </div>
    </SectionShell>
  );
}
